export const initVirtualBankList = () => [
    {
        name: '',
        account: '',
    },
    {
        name: '',
        account: '',
    },
];
export default {
    storeDetail: null,
    virtualBankList: initVirtualBankList(),
};
